import { render, staticRenderFns } from "./LocationInfoText.vue?vue&type=template&id=0b717bb4&"
import script from "./LocationInfoText.vue?vue&type=script&lang=ts&"
export * from "./LocationInfoText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports